module.exports = __webpack_public_path__ + "static/img/853_phase_function_Paper_PointsHejduk_Prediction.a5fee05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/853_phase_function_Paper_PointsHejduk_Prediction.png
// module id = iRkF
// module chunks = 0